import React, { useState, useEffect } from "react";
import {
  useSelector,
  userActions,
  resourcesActions,
  contingentsActions,
  productsActions,
  locationActions,
  taskActions,
  membershipTypeActions,
  ordersActions,
} from "inbooma-api";
// @ts-ignore
import t from "../helpers/t";
// @ts-ignore
import { Biscuit } from "../../utils";
import ComboSelectItem from "./comboselectitem";
import InboomaSelectBoxItem from "./InboomaSelectBoxItem";
import { Filter, FieldsMap } from "./Types/InboomaSelectBoxTypes";
import { strstr } from "../../utils/Helper";

type Props = {
  items?: any;
  model?: string;
  fields?: FieldsMap;
  selectField?: string;
  showFields?: string[];
  searchParams?: {
    [key: string]: string[] | string;
  };
  sortBy?: string;
  sortDirection?: string;
  quickOrder?: boolean;
  advanced?: boolean;
  placeholder?: string;
  selectedItems: any[] | any;
  setSelectedItems: (items: any) => void;
  dispatch: (payload: any) => void;
  container?: string;
  multiSelect?: boolean;
  openListOnClose?: boolean;
  extraStyle?: React.CSSProperties;
  onReset?: (val: any) => void;
  disabled?: boolean;
  onSelectItem?: (item: any) => void;
  extraFilter?: Filter | null;
  preSetItems?: { [key: string]: any } | null;
};

const InboomaSelectBox = ({
  items = [],
  model = "user",
  fields = {
    fieldMap: {
      last_name: {
        label: t("last_name"),
        number: "2",
        class: "inb-select-width-1",
        type: "default",
        style: { minWidth: "110px", width: "21%", padding: 0 },
      },
      first_name: {
        label: t("first_name"),
        number: "1",
        class: "inb-select-width-1",
        type: "default",
        style: { minWidth: "110px", width: "21%", padding: 0 },
      },
      customer_nbr: {
        label: t("user_nbr"),
        number: "3",
        class: "inb-select-width-2",
        type: "default",
        style: { minWidth: "100px", width: "19%", padding: 0 },
      },
      email: {
        label: t("e-mail"),
        number: "4",
        class: "inb-select-width-3",
        type: "toShorten",
        style: { minWidth: "200px", width: "35%", padding: 0 },
      },
      created: {
        label: t("created_at"),
        number: "5",
        class: "inb-select-width-4",
        type: "date",
        style: { minWidth: "140px", width: "24%", padding: 0 },
      },
    },
    fieldNames: ["last_name", "first_name", "customer_nbr", "email", "created"],
  },
  selectField = "id",
  showFields = ["last_name", "first_name", "customer_nbr", "email", "created"],
  searchParams = {
    param: "q",
    checkFields: ["name"],
  },
  sortBy,
  sortDirection,
  quickOrder,
  advanced,
  placeholder,
  selectedItems,
  setSelectedItems,
  dispatch,
  container,
  multiSelect = true,
  openListOnClose = multiSelect,
  extraStyle = {},
  onReset,
  disabled = false,
  onSelectItem,
  extraFilter = null,
  preSetItems = null,
}: Props) => {
  const [localItems, setLocalItems] = useState(function () {
    let t: { [key: string]: any } = {};
    t[model] = items;
    return t;
  });
  const [selectedIds, setSelectedIds] = useState(function () {
    let t: { [key: string]: any } = {};
    t[model] = [];
    return t;
  });
  const [localSelectedItems, setLocalSelectedItems] = useState(function () {
    let t: { [key: string]: any } = {};
    console.log("selectedItems", selectedItems);
    if (multiSelect) {
      t[model] = selectedItems;
    } else if (typeof selectedItems[0] !== "undefined") {
      t[model] = { label: selectedItems[0].name, value: selectedItems[0].id };
    } else {
      t[model] = { label: selectedItems.name, value: selectedItems.id };
    }
    return t;
  });
  const [stickyTemp, setStickyTemp] = useState(null);
  const _users = useSelector((state: { users_data: { users: any } }) => state.users_data.users);
  const _resources = useSelector(
    (state: { resources_data: { getResources: any } }) => state.resources_data.getResources,
  );
  const _contingents = useSelector(
    (state: { contingents_data: { contingents: any } }) => state.contingents_data.contingents,
  );
  const _products = useSelector(
    (state: { products_data: { products: any } }) => state.products_data.products,
  );
  const _locations = useSelector(
    (state: { locations_data: { locations: any } }) => state.locations_data.locations,
  );
  const _tasks = useSelector((state: { tasks: { tasks: any } }) => state.tasks.tasks);
  const _membershipTypes = useSelector(
    (state: { membership_types_data: { membershipTypes: any } }) =>
      state.membership_types_data.membershipTypes,
  );
  const _orders = useSelector((state: { orders: { orders: any } }) => state.orders.orders);
  const [itemsPending, setItemsPending] = useState(function () {
    let t: { [key: string]: any } = {};
    t[model] = false;
    return t;
  });
  const [standardFilter, setStandardFilter] = useState(
    model === "user"
      ? {
          findForSelect: 1,
          find: "short",
          active: 1,
          limit: 999,
          sort: "created",
          direction: "desc",
        }
      : model === "location"
        ? { findForSelect: 1, limit: 999, sort: "created", direction: "desc" }
        : model === "contingent"
          ? { findForSelect: 1, limit: 999, sort: "created", direction: "desc" }
          : model === "product"
            ? { limit: 999 }
            : model === "task"
              ? { limit: 999, sort: "created", direction: "desc" }
              : model === "membershipType"
                ? { limit: 999, sort: "name", direction: "asc" }
                : model === "order"
                  ? { find: "full", limit: 40, sort: "order_nbr", direction: "desc" }
                  : {},
  );
  const reset = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    const sInput: any = document.getElementById("inbooma-select-box__input_" + model);
    const reset: any = document.getElementById("inbooma-select-box__reset_" + model);
    if (sInput !== null && reset !== null) {
      reset.classList.add("hide");
      sInput.value = "";
      sInput.innerHTML = "";
      let r: { [key: string]: any } = {};
      r[model] = [];
      setLocalSelectedItems(r);
      setSelectedIds(r);
      setSelectedItems(r[model]);
      if (typeof onReset !== "undefined") {
        onReset(null);
      }
      close();
      if (openListOnClose) {
        open();
      }
    }
  };
  const filterItems = (data: any) => {
    return data;
    /*let newArr = [];
        data.filter(function(u) {
            selectedItems.map(selected => {
                console.log(selected.id,'selected');
                if(selected.id === u.id){
                    return false;
                }
            });
            return true;
        }).map(item => {
            console.log(item.id,'to select');
            newArr.push(item);
        });
        return newArr;*/
  };

  const getItems = (filter: Filter | null = null) => {
    let clone: { [key: string]: any } = {};
    Object.assign(clone, standardFilter);
    if (filter !== null) {
      clone = filter;
      setStandardFilter(clone);
    }
    if (extraFilter !== null) {
      for (const [key, value] of Object.entries(extraFilter)) {
        clone[key] = value;
      }
      setStandardFilter(clone);
    }
    let clone2: { [key: string]: any } = {};
    Object.assign(clone2, itemsPending);
    clone2[model] = true;
    setItemsPending(clone2);
    switch (model) {
      case "user":
        dispatch(
          userActions.getUsers({
            token: Biscuit.get("token"),
            filter: clone,
          }),
        );
        break;
      case "resource":
        dispatch(
          resourcesActions.getResources({
            token: Biscuit.get("token"),
            filter: clone,
          }),
        );
        break;
      case "contingent":
        dispatch(
          contingentsActions.getContingents({
            token: Biscuit.get("token"),
            filter: clone,
          }),
        );
        break;
      case "product":
        dispatch(
          productsActions.getProducts({
            token: Biscuit.get("token"),
            filter: clone,
          }),
        );
        break;
      case "location":
        dispatch(
          locationActions.getLocations({
            token: Biscuit.get("token"),
            filter: clone,
          }),
        );
        break;
      case "task":
        dispatch(
          taskActions.getTasks({
            token: Biscuit.get("token"),
            filter: clone,
          }),
        );
        break;
      case "membershipType":
        dispatch(
          membershipTypeActions.getMembershipTypes({
            token: Biscuit.get("token"),
            filter: clone,
          }),
        );
        break;
      case "order":
        dispatch(
          ordersActions.getOrders({
            token: Biscuit.get("token"),
            filter: clone,
          }),
        );
        break;
      default:
        if (preSetItems !== null) {
          let i: { [key: string]: any } = {};
          Object.assign(i, localItems);
          Object.keys(preSetItems).map((key: string) => {
            if (filter !== null && typeof filter.q !== "undefined") {
              if (strstr(key, filter.q, true) || strstr(preSetItems[key], filter.q, true)) {
                i[model].push(filterItems(preSetItems[key]));
              }
            } else {
              i[model].push(filterItems(preSetItems[key]));
            }
          });
          setLocalItems(i);
          let clone3: { [key: string]: any } = {};
          Object.assign(clone3, itemsPending);
          clone3[model] = false;
          setItemsPending(clone3);
        }
        // else do nothing
        break;
    }
  };

  useEffect(() => {
    if (localItems[model].length === 0) {
      getItems();
    }
    if (selectedItems.length > 0) {
      let ids: { [key: string]: any } = {};
      Object.assign(ids, selectedIds);
      selectedItems.map((item: { id: any }) => {
        ids[model].push(item.id);
      });
      setSelectedIds(ids);
    }
  }, []);

  useEffect(() => {
    if (!itemsPending || _users.success === "") return;

    if (_users.success === true) {
      let i: { [key: string]: any } = {};

      Object.assign(i, localItems);
      i.user = filterItems(_users.data);
      console.log("in use effect for users", i);
      setLocalItems(i);
      // show notification
    } else {
      // show notification
    }
    let clone: { [key: string]: any } = {};
    Object.assign(clone, itemsPending);
    clone.user = false;
    setItemsPending(clone);
  }, [_users]);

  useEffect(() => {
    if (!itemsPending || _resources.success === "") return;

    if (_resources.success === true) {
      let i: { [key: string]: any } = {};
      Object.assign(i, localItems);
      i.resource = filterItems(_resources.data);
      setLocalItems(i);
      // show notification
    } else {
      // show notification
    }
    let clone: { [key: string]: any } = {};
    Object.assign(clone, itemsPending);
    clone.resource = false;
    setItemsPending(clone);
  }, [_resources]);

  useEffect(() => {
    if (!itemsPending || _contingents.success === "") return;

    if (_contingents.success === true) {
      let i: { [key: string]: any } = {};
      Object.assign(i, localItems);
      i.contingent = filterItems(_contingents.data);
      setLocalItems(i);
      // show notification
    } else {
      // show notification
    }
    let clone: { [key: string]: any } = {};
    Object.assign(clone, itemsPending);
    clone.contingent = false;
    setItemsPending(clone);
  }, [_contingents]);

  useEffect(() => {
    if (!itemsPending || _products.success === "") return;

    if (_products.success === true) {
      let i: { [key: string]: any } = {};
      Object.assign(i, localItems);
      i.product = filterItems(_products.data);
      setLocalItems(i);
      // show notification
    } else {
      // show notification
    }
    let clone: { [key: string]: any } = {};
    Object.assign(clone, itemsPending);
    clone.product = false;
    setItemsPending(clone);
  }, [_products]);

  useEffect(() => {
    if (!itemsPending || _tasks.success === "") return;

    if (_tasks.success === true) {
      let i: { [key: string]: any } = {};
      Object.assign(i, localItems);
      i.task = filterItems(_tasks.data);
      setLocalItems(i);
      // show notification
    } else {
      // show notification
    }
    let clone: { [key: string]: any } = {};
    Object.assign(clone, itemsPending);
    clone.task = false;
    setItemsPending(clone);
  }, [_tasks]);

  useEffect(() => {
    if (!itemsPending || _locations.success === "") return;

    if (_locations.success === true) {
      let i: { [key: string]: any } = {};
      Object.assign(i, localItems);
      i.location = filterItems(_locations.data);
      setLocalItems(i);
      // show notification
    } else {
      // show notification
    }
    let clone: { [key: string]: any } = {};
    Object.assign(clone, itemsPending);
    clone.location = false;
    setItemsPending(clone);
  }, [_locations]);

  useEffect(() => {
    if (!itemsPending || _membershipTypes.success === "") return;

    if (_membershipTypes.success === true) {
      let i: { [key: string]: any } = {};
      Object.assign(i, localItems);
      i.membershipType = filterItems(_membershipTypes.data);
      setLocalItems(i);
      // show notification
    } else {
      // show notification
    }
    let clone: { [key: string]: any } = {};
    Object.assign(clone, itemsPending);
    clone.location = false;
    setItemsPending(clone);
  }, [_membershipTypes]);

  useEffect(() => {
    if (!itemsPending || _orders.success === "") return;

    if (_orders.success === true) {
      let i: { [key: string]: any } = {};
      Object.assign(i, localItems);
      i.order = filterItems(_orders.data);
      setLocalItems(i);
      // show notification
    } else {
      // show notification
    }
    let clone: { [key: string]: any } = {};
    Object.assign(clone, itemsPending);
    clone.location = false;
    setItemsPending(clone);
  }, [_orders]);

  let resetStyle: React.CSSProperties = { float: "unset" };
  if (!advanced) {
    resetStyle = {};
  }
  const onSearch = (query: string) => {
    let filter: Filter = standardFilter;
    filter.sort = "created";
    filter.sortDirection = "desc";
    filter.q = query;
    getItems(filter);
  };

  const _search = () => {
    if (advanced) {
      // _toggleResetBtn();
      const searchInput: HTMLCollectionOf<any> = document.getElementsByClassName(
        "inbooma-select-box__input",
      );
      let query = searchInput[0].value.toLowerCase();
      let filter = standardFilter;
      if (typeof searchParams.param === "string") {
        // @ts-ignore
        filter[searchParams.param] = query;
      }
      getItems(filter);
    }
  };

  const onRemoveHandler = (
    e: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    mod: any,
    index: number,
  ) => {
    if (disabled) {
      return;
    }
    let clone: { [key: string]: any } = {};
    Object.assign(clone, localSelectedItems);
    clone[model].splice(index, 1);
    setLocalSelectedItems(clone);
    let cl: { [key: string]: any } = {};
    Object.assign(cl, selectedIds);
    let foundIndex: number = -1;
    cl[model].map(function (value: number | string, ind: number) {
      if (value === mod.id) {
        foundIndex = ind;
      }
    });
    if (foundIndex > -1) {
      cl[model].splice(foundIndex, 1);
    }
    setSelectedItems(clone[model]);
    setSelectedIds(cl);
  };

  const _onSelectedItemMultiselect = (item: any) => {
    let clone: { [key: string]: any } = {};
    Object.assign(clone, localSelectedItems);
    const searchInput: any = document.getElementById("searchMultiSelect_" + model);
    searchInput.innerHTML = "";
    searchInput.value = "";
    if (selectField === "name" && model === "user") {
      item.name = item.first_name + " " + item.last_name;
      if (onSelectItem) {
        onSelectItem(item);
      }
      clone[model].push(item);
      setLocalSelectedItems(clone);
    } else {
      if (onSelectItem) {
        onSelectItem(item);
      }
      clone[model].push(item);
      setLocalSelectedItems(clone);
      setSelectedItems(clone[model]);
    }

    let cl: { [key: string]: any } = {};
    Object.assign(cl, selectedIds);
    cl[model].push(item.id);
    setSelectedIds(cl);
    //close();
  };

  const _onSelectedItem = (item: any) => {
    const searchInput: any = document.getElementById("inbooma-select-box__input_" + model);
    if (model === "user") {
      if (searchInput !== null) {
        item.name = searchInput.value = item.last_name + ", " + item.first_name;
      }
    }
    if (model === "order") {
      item.name = item.order_nbr + ", " + item.user.first_name + " " + item.user.last_name;
    }
    let clone: { [key: string]: any } = {};
    if (multiSelect) {
      Object.assign(clone, localSelectedItems);
      clone[model].label = item.name;
      clone[model].value = item.id;
    } else {
      clone[model] = {
        label: item.name,
        value: item.id,
      };
    }
    setLocalSelectedItems(clone);
    searchInput.innerHTML = item.name;
    const reset: any = document.getElementById("inbooma-select-box__reset_" + model);
    reset.classList.remove("hide");

    let cl: { [key: string]: any } = {};
    if (multiSelect) {
      Object.assign(cl, selectedIds);
    } else {
      cl[model] = [];
      close();
    }
    cl[model].push(item.id);
    setSelectedIds(cl);
    if (onSelectItem) {
      onSelectItem(item);
    }
  };

  const open = () => {
    if (disabled) {
      return;
    }
    if (quickOrder) {
      const stickyTopSidebar: any = document.getElementsByClassName("sticky-top-filter");
      if (typeof stickyTopSidebar[0] !== "undefined") {
        setStickyTemp(stickyTopSidebar[0]);
        stickyTopSidebar[0].classList.remove("sticky-top-filter");
      }
    }
    let cont: string = "";
    if (container) {
      cont = container;
    }
    const vcard: any = document.getElementById(cont);
    if (vcard !== undefined && vcard != null) vcard.classList.add("hide");
    const resultsList = document.getElementById("inbooma-select-box-results_" + model);
    if (resultsList !== null) {
      resultsList.classList.remove("hide");
    }
    const resultsListHeader: any = document.getElementById("inb-select-results-head_" + model);
    if (advanced) resultsListHeader.classList.remove("hide");
    /* const duplicateWarning = document.getElementById('inbooma-select-box-warning');
         duplicateWarning.classList.add('hide');*/
  };

  const isOpen = () => {
    const resultsList: any = document.getElementById("inbooma-select-box-results_" + model);
    let open: boolean = false;
    if (resultsList !== null) {
      open = !(resultsList.className.indexOf("hide") >= 0);
    }
    return open;
  };

  const close = () => {
    if (typeof container === "undefined") {
      container = "";
    }
    const vcard: any = document.getElementById(container);
    if (vcard !== undefined && vcard != null) vcard.classList.remove("hide");

    /* if (openListOnClose) {
            return;
        }*/

    const resultsList = document.getElementById("inbooma-select-box-results_" + model);
    if (advanced && resultsList) resultsList.classList.add("hide");
    const resultsListHeader: any = document.getElementById("inb-select-results-head_" + model);
    if (advanced && resultsListHeader) resultsListHeader.classList.add("hide");
    if (stickyTemp !== null) {
      // @ts-ignore
      stickyTemp.classList.add("sticky-top-filter");
    }

    return this;
  };

  const onItemSearchChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (!multiSelect) {
      const searchInput: any = document.getElementById("inbooma-select-box__input_" + model);
      searchInput.value = value;
      searchInput.innerHTML = value;
      let i: { [key: string]: any } = {};
      Object.assign(i, localSelectedItems);
      i[model] = {
        value: "i",
        label: value,
      };
      setLocalSelectedItems(i);
    }
    let data;
    switch (model) {
      case "user":
        data = _users.data;
        break;
      case "location":
        data = _locations.data;
        break;
      case "contingent":
        data = _contingents.data;
        break;
      case "product":
        data = _products.data;
        break;
      case "task":
        data = _tasks.data;
        break;
    }
    let filter: Filter = {};
    filter = Object.assign(filter, standardFilter);
    let param: string = "";
    if (typeof searchParams.param === "string") {
      param = searchParams.param;
    } else {
      param = searchParams?.param?.[0] || "";
    }
    filter[param] = value;
    getItems(filter);
  };

  const onItemSearchBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTimeout(() => {
      if (!advanced) close();
    }, 200);
  };

  const getValue = (item: any) => {
    // @ts-ignore
    let returnVal = item[showFields[0]];
    if (showFields.length > 1) {
      // @ts-ignore
      returnVal += ", " + item[showFields[1]];
    }
    return returnVal;
  };

  return (
    <>
      <div
        id={"inbooma-select-box_" + model}
        className={
          "inbooma-select-box " +
          (advanced && !quickOrder ? "advanced" : quickOrder ? "quick-order" : "")
        }
        style={extraStyle}
      >
        {!multiSelect &&
          typeof localSelectedItems !== "undefined" &&
          typeof localSelectedItems[model] !== "undefined" && (
            <>
              <input
                id={"inbooma-select-box__input_" + model}
                className="inbooma-select-box__input"
                style={{ width: "200px" }}
                placeholder={placeholder}
                onFocus={open}
                disabled={disabled}
                onChange={onItemSearchChanged}
                value={
                  typeof localSelectedItems[model].value !== "undefined"
                    ? localSelectedItems[model].label
                    : ""
                }
              />
              {!disabled && (
                <a
                  href="#"
                  id={"inbooma-select-box__reset_" + model}
                  className={
                    "inbooma-select-box__reset " +
                    (typeof localSelectedItems[model].value !== "undefined" ? "" : "hide")
                  }
                  style={resetStyle}
                  onClick={reset}
                >
                  x
                </a>
              )}
              {!disabled && (
                <InboomaSelectBoxItem
                  itemsPending={itemsPending}
                  items={localItems}
                  standardFilter={standardFilter}
                  getItems={getItems}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  _onSelectedItem={_onSelectedItem}
                  advanced={advanced}
                  quickOrder={quickOrder}
                  fields={fields}
                  model={model}
                  close={close}
                  selectedIds={selectedIds}
                />
              )}
            </>
          )}
        {multiSelect && (
          <>
            <span
              className="select2 select2-container select2-container--default select2-container--focus"
              dir="ltr"
              data-select2-id="2"
              style={{ width: "auto" }}
            >
              <span className="selection">
                <span
                  className="select2-selection select2-selection--multiple"
                  role="combobox"
                  aria-haspopup="true"
                  aria-expanded="false"
                  tabIndex={-1}
                >
                  <ul className="select2-selection__rendered" onClick={open}>
                    {localSelectedItems[model].map((item: any, index: number) => {
                      if (typeof item.id !== "undefined") {
                        return (
                          <ComboSelectItem
                            item={item}
                            value={getValue(item)}
                            disabled={disabled}
                            index={index}
                            onRemoveHandler={onRemoveHandler}
                          />
                        );
                      }
                      if (typeof item.name !== "undefined") {
                        return (
                          <ComboSelectItem
                            item={item}
                            value={item.name}
                            disabled={disabled}
                            index={index}
                            onRemoveHandler={onRemoveHandler}
                          />
                        );
                      }
                    })}

                    <li
                      className="select2-search select2-search--inline"
                      style={{ paddingTop: "5px" }}
                    >
                      <input
                        id={"searchMultiSelect_" + model}
                        className="select2-search__field2"
                        type="search"
                        tabIndex={0}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="none"
                        spellCheck="false"
                        disabled={disabled}
                        role="textbox"
                        aria-autocomplete="list"
                        placeholder={placeholder !== null ? placeholder : t("switch")}
                        onChange={onItemSearchChanged}
                        onBlur={onItemSearchBlur}
                      />
                    </li>
                  </ul>
                </span>
              </span>
              <InboomaSelectBoxItem
                itemsPending={itemsPending}
                items={localItems}
                standardFilter={standardFilter}
                getItems={getItems}
                sortBy={sortBy}
                sortDirection={sortDirection}
                _onSelectedItem={_onSelectedItemMultiselect}
                advanced={advanced}
                quickOrder={quickOrder}
                fields={fields}
                model={model}
                close={close}
                selectedIds={selectedIds}
                disabled={disabled}
              />
            </span>
          </>
        )}
      </div>
    </>
  );
};

export default InboomaSelectBox;
